import { Component, computed, inject, Input, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapsibleService } from './collapsible.service';
import { ResponsiveService } from '@/app/core/services/responsive.service';

@Component({
  selector: 'rdo-collapsible-button',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button
      (click)="service.toggle(key())"
      class="collapsible-button"
      [ngClass]="{
        'collapsible--collapsed': isCollapsed(),
        'collapsible--fixed': isFixed(),
        'collapsible--fixed-open': isMobileOpen(),
      }"
    >
      <div class="inner">
        <i class="icon fa fa-chevron-left"></i>
      </div>
    </button>
  `,
  styleUrls: ['./collapsible-button.component.scss'],
})
export class CollapsibleButtonComponent {
  key = input.required<string>();

  protected isFixed = computed(() => this.responsiveService.isMobile());
  protected isCollapsed = computed(() => {
    const currentKey = this.key();
    return this.service.getState(currentKey)() && !this.isFixed();
  });
  protected isMobileOpen = computed(() => this.service.isMobileOpen());

  constructor(
    public service: CollapsibleService,
    public responsiveService: ResponsiveService
  ) {}
}
